import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';


import videoCall from "../../assets/dust/video-call.svg";
import print from "../../assets/dust/print.svg";
import { APP_SUB_FOLDER, changeDayString } from '../../constants/app-constants';
import LodingComponent from '../../component/loding';

export default function Doctors({ doctors, consultType, hId, sId, callingType }) {
	const { hospitalSlug, specialitySlug, hospitalName, specialistName, specilityName } = useParams();
	const location = useLocation();
	const params = useParams();
	const [filteredDoctors, setFilteredDoctors] = useState([]);
	const [bookURL, setBookURL] = useState('');

	useEffect(() => {
		if (consultType === "0") setFilteredDoctors(doctors);
		if (consultType === "1") setFilteredDoctors(doctors.filter((doc) => doc.is_active_vc == 1));
		if (consultType === "2") setFilteredDoctors(doctors.filter((doc) => doc.is_active_opd == 1));
	}, [doctors, consultType]);

	useEffect(() => {
		let url = '';
		if (callingType === 'hospitals') {
			url = `${APP_SUB_FOLDER}/book-consult/hospitals/${hospitalSlug}/${specialitySlug}`;
			setBookURL(url);
		} else if (callingType === 'clinics') {
			url = `${APP_SUB_FOLDER}/book-consult/clinics/${specilityName}`;
			setBookURL(url);
		} else if (callingType === 'specialities') {
			url = `${APP_SUB_FOLDER}/book-consult/specialities/${specialistName}`;
			setBookURL(url);
		}
	}, [callingType, hospitalName, hospitalSlug, specialitySlug, specialistName])

	
	const displayDoctors = () => {
	
	//	if (!doctors) return (<div className="mhc-Loding"><img src={`${APP_SUB_FOLDER}../loader.gif`} alt="loader" /></div>);
	
	if(doctors?.length>0 ){
		return(
			<>
			{
				 filteredDoctors?.length>0 ?filteredDoctors?.map((item) => {
                    
					return (
					
						<div className="col-md-6 col-lg-6 col-xl-4 mb-3" key={item.id}>
								<Link
												to={
		
													(callingType && callingType === "doctors")
														? `${APP_SUB_FOLDER}/book-consult/doctors/${item.slug}/${item.id}/${item.hospital.id}/${item.specialities_slug[0]?.id}/${consultType}?consultType=${callingType}`
														: `${bookURL}/${item.slug}/${item.id}/${item.hospital.id}/${sId}/${consultType}?consultType=${callingType}`
												}
												className="text-decoration-none"
											>
							<div className="mhc-dector-card">
								<div className="row">
									<div className="col-9">
										<div className="d-flex align-items-start">
											<div className="img-holder">
												<img src={item.profile_image} alt='Profile'></img>
											</div>
											<div className="ms-3">
												<p className="m-0 fw-bolder  text-secondary text-tittle">
													{item.name}
												</p>
												<p className="text-secondary sub-text">
													{item.designation} <br />
													{item.experience> 0? <>Exp. {item.experience}+ Yrs<br /></> : ''}
													{callingType !== 'specialities' && Array.isArray(item.specialities) && <>{item.specialities.join(',')} <br/></>} 
													{callingType !== 'hospitals' && item.hospital && item.hospital.name}
												</p>
											</div>
										</div>
									</div>
									<div className="col-3 text-end">
										<ul className="list-unstyled gap-3 mb-0 d-flex justify-content-end">
											{item.is_active_vc === 1 && (
												<li>
													<img src={`${APP_SUB_FOLDER}${videoCall}`} className="icon" alt='MyHealthcare Video Call' />
												</li>
											)}
											{item.is_active_opd === 1 && (
												<li>
													<img src={`${APP_SUB_FOLDER}${print}`} className="icon" alt='MyHealthcare Print' />
												</li>
											)}
										</ul>
									</div>
								</div>
		
								<div className="d-flex justify-content-between align-items-center">
									<div>
										<ul className="list-unstyled d-flex flex-wrap mb-0 text-capitalize fs-6">
											{item.availability && item.availability.length > 0 && (
												<li className="px-1">
													<span className="text-secondary  me-2">Available</span>
												</li>
											)}
											{item && item.availability && Array.isArray(item.availability) && item.availability.map((day, index) => {
												return (
													<li className="px-1" key={day}>
														<span className="text-primary fw-bolder">
															{changeDayString(day)}
															{index + 1 !== item.availability.length && ", "}
														</span>
													</li>
												);
											})}
										</ul>
									</div>
									<div>
										{/* // <Link to={`/doctor-profile/${item.id}/${item.hospital.id}/${sId}/${consultType}`} */}
										{item.availability && item.availability.length > 0 ? (
											<Link
												to={
											
													(callingType && callingType === "doctors")
														? `${APP_SUB_FOLDER}/book-consult/doctors/${item.slug}/${item.id}/${item.hospital.id}/${item.specialities_slug[0]?.id}/${consultType}?consultType=${callingType}`
														: `${bookURL}/${item.slug}/${item.id}/${item.hospital.id}/${sId}/${consultType}?consultType=${callingType}`
												}
												className="btn btn-outline-primary rounded-1"
											>Book </Link>
										) : null}
									</div>
								</div>
							</div>
							</Link>
						</div>
					
					);
				})
				 
				 :	<p className="text-center fs-6 text-secondary fw-bold">There are currently no doctors available for the selected consult type, please select a different consult type to book appointments.</p>
			}
			</>
		)
       

	}else{
	return <p className="text-center fs-6 text-secondary fw-bold">Result Not Found</p>
    }
	};
	return displayDoctors()
}